import { useEffect, useState } from "react";

import AdminPage from "./components/AdminPage";
import { getDatabases, copyDatabase, backupDatabase, getBackups, restoreDatabase } from "./api/dbApi";

export default function DbMgr() {
  const [dbFrom, setDbFrom] = useState("");
  const [dbTo, setDbTo] = useState("");
  const [loading, setLoading] = useState(false);
  const [databases, setDatabases] = useState([]);

  const [selectedDb, setSelectedDb] = useState("");
  const [backups, setBackups] = useState([]);
  const [selectedBackup, setSelectedBackup] = useState("");
  const [showRestore, setShowRestore] = useState(false);

  useEffect(() => {
    async function loadDatabases() {
      try {
        const dbs = await getDatabases();
        setDatabases(dbs);
      } catch (err) {
        console.error(err);
        alert("Failed to load databases");
      }
    }

    loadDatabases();
  }, []);

  const handleCopy = async () => {
    if (!dbFrom || !dbTo) {
      alert("Both databases are required");
      return;
    }

    if (dbTo === "vr_live") {
      alert("DON'T COPY TO LVIE!");
      return;
    }

    setLoading(true);

    try {
      await copyDatabase(dbFrom, dbTo);

      setDbFrom("");
      setDbTo("");
      alert("Database copied successfully");
    } catch (error) {
      console.error("Database copy failed:", error);

      alert("Database copy failed");
    } finally {
      setLoading(false);
    }
  };

  const handleBackup = async () => {
    if (!selectedDb) {
        alert("Select a database");
        return;
    }

    try {
        setLoading(true);

        const result = await backupDatabase(selectedDb);

        alert(`Backup created:\n${result.file}`);
    } catch (err) {
        alert("Backup failed");
    } finally {
        setLoading(false);
    }
  };

  const handleLoadBackups = async () => {
    if (!selectedDb) {
        alert("Select a database");
        return;
    }

    try {
        setLoading(true);

        const files = await getBackups(selectedDb);

        setBackups(files);
        setSelectedBackup(files[0] || "");
        setShowRestore(true);

    } catch (err) {
        alert("Couldn't load backups");
    } finally {
        setLoading(false);
    }
  };

  const handleRestore = async () => {

    if (!selectedBackup)
        return;

    if (
        !window.confirm(
            `Restore ${selectedDb} from\n\n${selectedBackup}\n\nA backup of the current database will be created automatically.`
        )
    ) {
        return;
    }

    try {
        setLoading(true);

        await restoreDatabase(
            selectedDb,
            selectedBackup
        );

        alert("Database restored successfully.");

        setShowRestore(false);

    } catch (err) {
        alert("Restore failed");
    } finally {
        setLoading(false);
    }
  };

  return (
    <AdminPage
      title='Database Manager'
      subtitle='Copy data between environments'
    >
      <div className='max-w-5xl mx-auto'>
        <div className='bg-[#1a1d24] border border-slate-800 rounded-2xl p-6 shadow-lg'>
          <h2 className='text-xl font-bold text-white mb-6'>Copy Database</h2>
          <div className='flex flex-wrap gap-4'>
            <select
              value={dbFrom}
              onChange={(e) => setDbFrom(e.target.value)}
              className="w-48 bg-[#111318] border border-slate-700 rounded-xl px-4 py-3 text-white"
            >
              <option value="">Select source</option>
              {databases.map(db => (
                <option key={db} value={db}>
                  {db}
                </option>
              ))}
            </select>

            <select
              value={dbTo}
              onChange={(e) => setDbTo(e.target.value)}
              className="w-48 bg-[#111318] border border-slate-700 rounded-xl px-4 py-3 text-white"
            >
              <option value="">Select destination</option>
              {databases.map(db => (
                <option key={db} value={db}>
                  {db}
                </option>
              ))}
            </select>
            <button
              onClick={handleCopy}
              disabled={loading}
              className='bg-blue-600 hover:bg-blue-500 disabled:opacity-50 text-white font-semibold px-6 rounded-xl transition'
            >
              {loading ? "Copying..." : "Copy"}
            </button>
          </div>

          <h2 className='text-xl font-bold text-white mb-6 mt-6'>Backup / Restore Database</h2>
          <div className='flex flex-wrap gap-4'>
            <select
                value={selectedDb}
                onChange={(e) => setSelectedDb(e.target.value)}
                className="w-48 bg-[#111318] border border-slate-700 rounded-xl px-4 py-3 text-white"
            >
                <option value="">Select database</option>

                {databases.map(db => (
                    <option key={db} value={db}>
                        {db}
                    </option>
                ))}
            </select>

            <button
                onClick={handleBackup}
                className="bg-green-600 hover:bg-green-500 text-white px-6 rounded-xl"
            >
                Backup
            </button>

            <button
                onClick={handleLoadBackups}
                className="bg-orange-600 hover:bg-orange-500 text-white px-6 rounded-xl"
            >
                Restore
            </button>
          </div>

          <div className='flex flex-wrap gap-4'>
            {showRestore && (
              <>
                  <select
                      value={selectedBackup}
                      onChange={(e) => setSelectedBackup(e.target.value)}
                      className="w-96 bg-[#111318] border border-slate-700 rounded-xl px-4 py-3 text-white"
                  >
                      {backups.map(file => (
                          <option
                              key={file}
                              value={file}
                          >
                              {file}
                          </option>
                      ))}
                  </select>

                  <button
                      onClick={handleRestore}
                      className="bg-red-600 hover:bg-red-500 text-white px-6 rounded-xl"
                  >
                      Restore Now
                  </button>
              </>
            )}
          </div>

          <div className='mt-6 text-sm text-yellow-400 bg-yellow-500/10 border border-yellow-500/20 rounded-xl p-4'>
            ⚠️ Be careful when copying databases. Always verify the destination
            before running.
          </div>
        </div>
      </div>
    </AdminPage>
  );
}
